module.exports = __webpack_public_path__ + "img/default.a8cb614b.png";